'use client'

import { Button, Icon } from '@/shared/ui'

import { useGetContractRoom } from '../../api/get-contract-room'

type Props = {
  roomId: number
  contractId: number
  roomUrl: string
}

export const RoomDetailButton = ({ roomId, contractId, roomUrl }: Props) => {
  const { getContractRoom } = useGetContractRoom()

  const handleClick = async () => {
    const { response: contractRoom } = await getContractRoom(roomId, contractId)

    if (contractRoom) {
      window.open(roomUrl, '_blank', 'noopener,noreferrer')
    }
  }

  return (
    <Button
      variant="outline"
      size="medium"
      color="primary"
      shape="pill"
      fullWidth
      onClick={handleClick}
    >
      방 세부 정보
      <Icon name="arrow-right" />
    </Button>
  )
}
